import React from 'react';
import Helmet from 'react-helmet';
import qs from 'qs';

import { PageWrapper, TabbedArea, FormSelection } from '../components';


const FAQPanel = ({ title }) => (
  <TabbedArea>
    <TabbedArea.Pane title="Start Your Application">
      <p>
        Complete our user-friendly online EIN Application Assistant in just 3 simple steps, to
        safely and securely get a Federal Tax ID (EIN) Number for your business and/or personal
        needs. Following approval, you will receive your Tax ID (EIN) Number via email in a
        printable format which you can immediately use. In the event there are any errors on your
        EIN Application our agents will work with the IRS on your behalf to correct any
        inaccuracies. This site offers a paid service in which our agents will prepare and submit
        your EIN Application to the IRS on your behalf for a paid fee based on your delivery
        needs. Alternatively, for no charge at all you can visit the official IRS.gov website and
        complete the EIN Application on your own without our assistance. This site is not
        affiliated with any government agency or official service. Our agents are standing by
        waiting to assist you.
        <strong>
          <span style={{ textTransform: 'uppercase' }}>
            {' '} To get started now, choose your entity type below.
          </span>
        </strong>
      </p>
    </TabbedArea.Pane>
    <TabbedArea.Pane title="What is an EIN Number?">
      <p>
        Your EIN or Employer Identification Number is used by the IRS to identify you as a tax
        paying business entity, and many people think of an EIN as their business social security
        number. Like a social security number, an EIN is a unique nine-digit number assigned by
        the Internal Revenue Service to business entities (and in some cases individuals)
        operating in the United States for the purposes of identification.
      </p>
    </TabbedArea.Pane>
    <TabbedArea.Pane title="Do I Need an EIN?">
      <p>In most cases, you need an EIN Number under any of the following circumstances:</p>
      <ul>
        <li>Your business is new</li>
        <li>You need to pay business taxes</li>
        <li>You have one or more employees</li>
        <li>You want to start a line of business credit</li>
        <li>You plan to open a business bank account</li>
        <li>You form an LLC, Corporation, or Partnership</li>
      </ul>
    </TabbedArea.Pane>
    <TabbedArea.Pane title="How do I Apply?">
      <p>
        {title} ® provides a safe and secure method for obtaining a new EIN number
        online, without the need to fill out complex and confusing government forms. Upon
        approval by the IRS, your Federal Tax ID (EIN) Number will be sent via email, for
        you to print and start using immediately for many of your business needs. You will
        also receive a copy of your EIN in the mail. We can have your EIN number approved
        in 60 minutes or less. This site offers a paid service in which our agents will
        prepare and submit your EIN Application to the IRS on your behalf for as low as $247
        up to $297 depending on your delivery needs. Alternatively, for no charge at all you
        can visit the official IRS.gov website and complete the EIN Application on your own
        without our assistance.
      </p>
    </TabbedArea.Pane>
    <TabbedArea.Pane title="Why Choose Us?">
      <p>
        Save time preparing complicated government forms and prevent errors by using our
        easy-to-use online EIN Application Assistant. You can obtain an SS-4 form and try and
        complete it yourself, or use the IRS website to obtain your number, however if there
        is any problem with your information you could be forced to call the IRS and spend hours
        waiting on-hold. For a small fee we will prepare your SS-4 form and work with the IRS
        to obtain your (EIN) number and deliver it to you quickly and securely via email. If you
        need to make changes to your information on record with the IRS our agents will provide
        you with support in updating or correcting your information for no additional fee. Our
        service makes the employment identification number (EIN) application process quick, easy,
        and accurate for both individuals and businesses. This site is not affiliated with any
        government agency.
      </p>
    </TabbedArea.Pane>
  </TabbedArea>
);


const IndexPage = ({ data, location: { hash = '' } }) => {
  try {
    if (hash) {
      const queryString = hash.split('?').slice(-1)[0];
      const queryParams = qs.parse(queryString);
      if (Object.keys(queryParams).length > 0) {
        localStorage.setItem('queryParams', JSON.stringify(queryParams));
      }
    }
  } catch (SyntaxError) {
    console.error('JSON stringify error');
  }
  return (
    <React.Fragment>
      <Helmet>
        <script type="text/javascript">
          {`
            ga('require', 'ec');

            ga('ec:addImpression', {
              'id': 'sole-proprietor-application',
              'name': 'Sole Proprietor Application',
              'position': 1
            });
            ga('ec:addImpression', {
              'id': 'limited-liability-company-application',
              'name': 'Limited Liability Company Application',
              'position': 2
            });
            ga('ec:addImpression', {
              'id': 'trust-application',
              'name': 'Trust Application',
              'position': 3
            });
            ga('ec:addImpression', {
              'id': 'estate-application',
              'name': 'Estate Application',
              'position': 4
            });
            ga('ec:addImpression', {
              'id': 'non-profit-application',
              'name': 'Non-Profit Application',
              'position': 5
            });
            ga('ec:addImpression', {
              'id': 'partnership-application',
              'name': 'Partnership Application',
              'position': 6
            });
            ga('ec:addImpression', {
              'id': 'corporation-application',
              'name': 'Corporation',
              'position': 7
            });
            ga('ec:addImpression', {
              'id': 'scorporation-application',
              'name': 'Corporation',
              'position': 8
            });
            ga('ec:addImpression', {
              'id': 'personal-service-application',
              'name': 'Personal Service Corporation',
              'position': 9
            });
            ga('ec:addImpression', {
              'id': 'church-organization-application',
              'name': 'Church Organization Application',
              'position': 10
            });
          `}
        </script>
      </Helmet>
      <PageWrapper step={1}>
        <h4 className="siteSubHeader">Start Your Federal Tax ID Application - Get Your Employee Identification Number (EIN) Today</h4>
        <div className="row">
          <div className="col-lg-12 visible-md visible-lg">
            <div className="formDetails">
              <h6 className="formDetails__subHeader">Start Your EIN Application Here</h6>
              <div className="formDetails__content">
                <h4>The Easiest Way To Launch Your Business Today</h4>
                <ul className="square">
                  <li>Simple 3 Step Process For Your EIN</li>
                  <li>We Review Your Entire Application, Saving Your Time and Money</li>
                  <li>Our Form Takes Just Minutes to Complete</li>
                  <li>Fast Review and Turnaround</li>
                  <li>100% Error Free. Guaranteed.</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-sm-12 col-md-12 visible-md visible-lg">
            <div className="formDetails">
              <h6 className="formDetails__subHeader_round">Step 1: Select Your Entity Type Below</h6>
            </div>
          </div>
        </div>
        <FormSelection />
        <div className="row">
          <div className="col-sm-12 col-md-12 visible-md visible-lg">
            <div className="formDetails">
              <h6 className="formDetails__subHeader">
                Our Simple EIN Application Takes Just Minutes.
              </h6>
              <div className="formDetails__content">
                <p>
                  Every business needs a Tax ID (EIN) to operate.
                  {' '}
                  We make that process simple for you, because we know you have other things to do.
                </p>
                <h5>
                  What is an Employee Identification Number (EIN)? An EIN allows your business to:
                </h5>
                <ul className="square">
                  <li>Open a Bank Account</li>
                  <li>Start Payroll</li>
                  <li>File Federal and State Reports</li>
                  <li>File Tax Returns</li>
                  <li>Obtain Lines of Credit</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </PageWrapper>
    </React.Fragment>
  );
};

export default IndexPage;

export const query = graphql`
  query SiteTitleQuery {
    site {
      siteMetadata {
        title,
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/pages/index.js